var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9282 12.4215L9.62517 20.475C9.48381 20.5308 9.3633 20.6292 9.2803 20.7566C9.1973 20.8839 9.15592 21.0339 9.16188 21.1858C9.16784 21.3376 9.22084 21.4839 9.31356 21.6044C9.40628 21.7248 9.53413 21.8135 9.67943 21.8581L14.7966 23.4421L16.872 29.8646C16.9098 29.9819 16.9766 30.0878 17.0662 30.1725C17.1559 30.2572 17.2654 30.3179 17.3847 30.349C17.504 30.3802 17.6292 30.3807 17.7488 30.3507C17.8683 30.3206 17.9784 30.2609 18.0688 30.177L21.0754 27.3845L26.7793 31.5821C26.877 31.6539 26.9911 31.7004 27.1112 31.7173C27.2313 31.7343 27.3538 31.7212 27.4676 31.6792C27.5814 31.6371 27.683 31.5676 27.7633 31.4767C27.8436 31.3857 27.9001 31.2763 27.9277 31.1582L31.898 14.1199C31.959 13.859 31.9473 13.5864 31.8643 13.3316C31.7813 13.0769 31.6301 12.8497 31.4271 12.6748C31.2241 12.4999 30.9771 12.384 30.7128 12.3396C30.4486 12.2952 30.1772 12.3241 29.9282 12.423V12.4215ZM18.0424 24.7782L17.4088 28.5769L15.9421 23.2587L30.2714 13.9087L18.0424 24.7767V24.7782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.0ebb7c5273e9b28df723a733d61e7b4f.svg";
export { ForwardRef as ReactComponent };